<template>
  <div id="pending-plans">
    <b-row>
      <b-col cols="12">
        <div class="wrap dash-card p-4 bg-white shadow-lg">
          <h6 class="mb-0">
            Need help confirming your payment?
          </h6>
          <b-button size="sm" variant="dark" @click="openSupport()"
            >Contact Support</b-button
          >
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4" v-if="loadingData && !loadError">
      <b-col v-for="item in 3" cols="12" md="6" lg="4" :key="item" class="mb-4">
        <b-progress
          variant="primary"
          :max="100"
          class="w-100"
          show-progress
          animated
          height="200px"
        >
          <b-progress-bar :value="100">Loading...</b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
    <b-row v-else-if="loadError" class="mt-4" align-v="stretch">
      <b-col cols="12" class="mb-4">
        <div class="text-center" title="Could not load, click on retry">
          <b-button
            size="sm"
            @click="
              loadFarmRequests();
              loadPayments();
            "
            variant="light"
            class="w-100"
            style="height:200px"
          >
            <bad-network-icon />
            <br />Error Loading Data, <br />click to retry
            <reload-icon class="ml-1" />
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4" v-else align-v="stretch">
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-4"
        v-for="payment in payments"
        :key="payment.id + 'payment'"
      >
        <b-button
          @click="openPaymentDetails(payment)"
          variant="white"
          class="w-100 wrapper h-100 p-4 bg-white dash-card payment-blocks text-left"
        >
          <div class="upper mb-5">
            <b-row align-h="between">
              <b-col cols="9">
                <h4 class="mb-0" v-if="payment.status == 'active'">
                  <Money :value="payment.amount || 0" />
                </h4>
                <h4 class="mb-0" style="font-size:18px" v-else>
                  Pending Payment
                </h4>
                <small class="text-dark" v-if="payment.status == 'active'"
                  >{{ parseInt(payment.amount) / 50000 }} Unit(s)</small
                >
                <!-- <small class="text-dark" v-else>Reference: {{ payment.reference }}</small> -->
              </b-col>
              <b-col class="text-right">
                <i
                  v-if="payment.status == 'active'"
                  class="fa fa-check-circle fa-lg text-primary"
                  aria-hidden="true"
                ></i>
                <i
                  v-else
                  class="fas fa-exclamation-circle fa-lg text-warning"
                  aria-hidden="true"
                ></i>
              </b-col>
            </b-row>
          </div>
          <div class="upper">
            <b-row align-h="between">
              <b-col>
                <small
                  class="d-payment text-dark"
                  v-if="payment.status == 'active'"
                >
                  Maturity:
                  {{
                    LuxonDateTime.fromJSDate(
                      new Date(payment.maturity)
                    ).toFormat("LLL dd yyyy")
                  }}
                </small>
                <small class="d-payment text-dark" v-else>
                  Purchase Date:
                  {{
                    LuxonDateTime.fromJSDate(
                      new Date(payment.createdat)
                    ).toFormat("LLL dd yyyy")
                  }}
                </small>
              </b-col>
              <b-col>
                <!-- <component :is="`${payment.type}-icon`" :size="50"></component> -->
              </b-col>
            </b-row>
            <!-- {{payment}} -->
          </div>
        </b-button>
      </b-col>
      <!-- <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-4"
        v-for="request in requests"
        :key="request.id + 'request'"
      >
        <b-button
          @click="openRequestModal(request)"
          variant="white"
          class="w-100 wrapper h-100 p-4 bg-white dash-card investment-blocks text-left"
        >
          <div class="upper mb-5">
            <b-row align-h="between">
              <b-col cols="9">
                <h4 class="mb-0" v-if="request.status == 'approved'">
                  <Money :value="request.package.price * request.units || 0" />
                </h4>
                <h4 class="mb-0" style="font-size:18px" v-else>
                  Pending Farm Request
                </h4>
              </b-col>
              <b-col class="text-right">
                <i
                  v-if="request.status == 'approved'"
                  class="fa fa-check-circle fa-lg text-primary"
                  aria-hidden="true"
                ></i>
                <i
                  v-else
                  class="fas fa-exclamation-circle fa-lg text-warning"
                  aria-hidden="true"
                ></i>
              </b-col>
            </b-row>
          </div>
          <div class="upper">
            <b-row>
              <b-col>
                <small class="d-investment text-dark">
                  <div>
                    {{
                      request.units +
                        " " +
                        request.package.plotsize +
                        " Plot at " +
                        request.location.locationname
                    }}
                  </div>
                  <h6 v-if="request.status == 'approved'">
                    <span class="badge badge-primary">Approved</span>
                    <small>Click to make payment</small>
                  </h6>
                  <h6 v-if="request.status == 'pending'">
                    <span class="badge badge-warning">Awaiting Approval</span>
                  </h6>
                  <h6 v-if="request.status == 'rejected'">
                    <span class="badge badge-danger">Rejected</span>
                  </h6>
                </small>
              </b-col>
            </b-row>
             {{request}}
          </div>
        </b-button>
      </b-col> -->
    </b-row>
    <b-row>
      <b-col cols="12" v-if="requests.length == 0 && payments.length == 0">
        <div
          class="d-flex bg-white dash-card p-5 align-items-center justify-content-center"
          style="height:200px"
        >
          <div class="wrap text-center">
            <h5>You have no pending payment or farm ownership request</h5>
            <b-button variant="primary" @click="$emit('setInvestTab')"
              >Own a Farm</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>
    <InvestmentDetailsModal :investment="activeInvestment" />
    <FarmPackagePayment
      v-if="activeRequest.id != undefined"
      :request="activeRequest"
    />
  </div>
</template>

<script>
import { DateTime as LuxonDateTime } from "luxon";
import { UserService } from "@/services";
import { formatMoney } from "@/utils/helpers";
import loadData from "@/mixins/loadData";
import InvestmentDetailsModal from "./InvestmentDetailsModal";
import FarmPackagePayment from "./FarmPackagePayment";

export default {
  data() {
    return {
      payments: [],
      requests: {},
      activeInvestment: {},
      activeRequest: {},
      LuxonDateTime: LuxonDateTime,
    };
  },
  mixins: [loadData],
  methods: {
    formatMoney,
    async loadFarmRequests() {
      this.loadingData = true;
      this.loadError = false;
      try {
        const { data } = await UserService.getFarmRequests();

        let requests = data.requests;

        this.requests = [];

        requests.forEach(request => {
          if (
            request.package.type == "sale" &&
            request.status != "subscribed"
          ) {
            this.requests.push(request);
          }
        });
      } catch (err) {
        this.loadError = true;
      } finally {
        this.loadingData = false;
      }
    },
    async loadPayments() {
      this.loadingData = true;
      this.loadError = false;
      try {
        const { data } = await UserService.getInvestments();

        let payments = data.payments;

        payments.forEach(payment => {
          if (payment.for == "sales") {
            this.payments.push(payment);
          }
        });
      } catch (err) {
        this.loadError = true;
      } finally {
        this.loadingData = false;
      }
    },
    openPaymentDetails(investment) {
      this.activeInvestment = investment;
      this.$bvModal.show("investment-details-modal");
    },
    openRequestModal(request) {
      this.activeRequest = request;
      this.$bvModal.show("request-modal");
    },
    openSupport() {
      try {
        this.$drift.openSideBar();
        this.$drift.hide();
      } catch (error) {
        //console.log(error);

        return;
      }
    }
  },
  components: {
    InvestmentDetailsModal,
    FarmPackagePayment
  },
  mounted() {
    this.loadFarmRequests();
    this.loadPayments();
  }
};
</script>

<style></style>
